import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import { branch } from 'baobab-react/higher-order'
import Paper from 'components/atoms/Paper'
import Typography from 'components/atoms/Typography'
import Input from 'components/shared/input/Input'
import ProfileRow from 'components/molecules/ProfileRow'
import { Button, FormGroup, Image } from 'components/qstrap'
import storage from 'utils/storage'
import AccessToken from 'utils/AccessToken'
import API from 'utils/API'
import csrfToken from 'utils/csrfToken'
import { omit } from 'lodash'

class ProfileEdit extends React.Component {
  constructor(props) {
    super(props)

    this.inputs = {}
    this.handleSubmit = this.handleSubmit.bind(this)
    this.isValid = this.isValid.bind(this)
    this.vpSubmit = this.vpSubmit.bind(this)
    this.loading = this.loading.bind(this)
    this.setSchoolMajor = this.setSchoolMajor.bind(this)
    this.handleChangePassword = this.handleChangePassword.bind(this)
    this.getInputs = this.getInputs.bind(this)
    this.fillCityOptions = this.fillCityOptions.bind(this)
    this.showSchoolSelect = this.showSchoolSelect.bind(this)
    this.setSchoolMajor = this.setSchoolMajor.bind(this)

    const schoolId = props.currentUser.school_id

    this.state = {
      provinces: [],
      provincesLoading: false,

      cities: [],
      citiesVisible: false,
      citiesLoading: false,

      schools: schoolId ? [{ id: schoolId, text: props.currentUser.school_name }] : [],
      schoolsVisible: false,

      gradeLevels: [],
      gradeLevelsLoading: false,

      majors: [],
      majorsVisible: false,

      changePassword: false,
    }
  }

  componentWillMount() {
    this.fillProvinceOptions()
    this.fillGradesOptions()
  }

  componentDidMount() {
    window.component = this


    if (this.props.currentUser.grade_level) this.setSchoolMajor()

    const { province } = this.props.currentUser
    if (province) {
      this.fillCityOptions(true, province)
      this.showSchoolSelect(true)
      this.inputs.school.value = this.props.currentUser.school_id
    }
  }

  setSchoolMajor() {
    const grade = this.attributes().grade_level
    window.a = this
    if (['g10', 'g11', 'g12'].includes(grade)) {
      this.setState({ majorsVisible: true })
    } else {
      this.setState({ majorsVisible: false })
      this.inputs.school_major.inputTag.setState({ value: 'not_yet_decided' })
      this.inputs.school_major.value = 'not_yet_decided'
    }
  }

  getInputs() {
    if (!this.state.changePassword) {
      return omit(this.inputs, ['password', 'current_password', 'password_confirmation'])
    }
    return this.inputs
  }

  fillGradesOptions() {
    const getGradesPath = `${API.endPoints().schools.grades}/id`

    this.setState({ gradeLevelsLoading: true }, () => {
      API.get(getGradesPath).then((response) => {
        let grades = response.data.map(grade => grade.slug).reverse()
        // exclude under_g9 grade slug code for quipper campus
        grades = grades.filter(e => new RegExp(/^(g9|g10|g11|g12|over_g12)$/).test(e))

        this.setState({
          gradeLevels: grades,
          gradeLevelsLoading: false,
        })
      })
    })
  }

  showSchoolSelect(validity) {
    this.clearInputValue('school')

    if (validity) {
      const hashValues = this.attributes()
      const { province, city } = this.props.currentUser

      this.setState({
        schoolsAjaxSource: `${API.endPoints().schools.select}?country_code=ID&province=${hashValues.province || province}&city=${hashValues.city || city}&limit=50&verified_only=true`,
        schoolsVisible: true,
      })
    }
  }

  fillCityOptions(validity, value) {
    this.clearInputValue('city')
    this.clearInputValue('school')

    if (validity) {
      const getCitiesPath = `${API.endPoints().schools.cities}?country_code=ID&province=${value}`
      const initialLoadStates = {
        citiesLoading: true,
        citiesVisible: true,
        schoolsVisible: false,
      }

      this.setState(initialLoadStates, () => {
        API.get(getCitiesPath).then((response) => {
          this.setState({
            cities: response.data,
            citiesLoading: false,
          })
        })
      })
    }
  }

  fillProvinceOptions() {
    const getProvincesPath = `${API.endPoints().schools.provinces}?country_code=ID`
    const initialLoadStates = {
      provincesLoading: true,
      citiesVisible: false,
      schoolsVisible: false,
    }

    this.setState(initialLoadStates, () => {
      API.get(getProvincesPath).then((response) => {
        this.setState({
          provinces: response.data,
          provincesLoading: false,
        })
      })
    })
  }

  clearInputValue(name) {
    this.inputs[name].value = this.props.currentUser[name] || ''
    this.inputs[name].setState({ clientSideErrors: [] })

    if (name === 'school') {
      this.inputs.school.inputTag.setState({ value: this.props.currentUser.school_id })
    }
  }

  defaultSelectInputOptions(inputPlaceholder) {
    return {
      placeholder: inputPlaceholder,
      theme: 'qstrap',
    }
  }

  schoolSelectInputOptions() {
    const options = this.defaultSelectInputOptions(intl.get('account.your_school'))

    options.minimumInputLength = 1
    options.ajax = {
      url: this.state.schoolsAjaxSource,
      dataType: 'json',
      data(params) {
        return { query: params.term }
      },
    }

    return options
  }

  isValid() {
    const inputs = this.getInputs()
    return !Object.keys(inputs).map(key => inputs[key].validate()).includes(false)
  }

  loading(state) {
    if (state) {
      this.loader.classList.remove('hide')
    } else {
      this.loader.classList.add('hide')
    }
  }

  attributes() {
    const inputs = this.getInputs()
    const hash = {}
    Object.keys(inputs).forEach(key => hash[key] = inputs[key].value || this.props.currentUser[key])
    return hash
  }

  handleSubmit(e) {
    e.preventDefault()
    this.loading(true)

    if (this.isValid()) {
      const options = {
        headers: { Authorization: `Token ${AccessToken.get()}` },
      }
      const hash = this.attributes()
      const data = {
        first_name: hash.first_name,
        last_name: hash.last_name,
        email: hash.email,
        grade_level: hash.grade_level,
        username: hash.username,
        old_username: this.props.currentUser.username,
        phone: hash.phone_number,
        current_password: hash.current_password,
        password: hash.password,
        password_confirmation: hash.password,
      }

      API.post(API.endPoints().profile.updateApi, data, options).then(() => {
        this.vpSubmit()
      }).catch((error) => {
        error.response.data.errors.forEach((value) => {
          const input = this.inputs[value.field]
          input.setState(() => ({ clientSideErrors: [value.code] }))
        })
        this.loading(false)
      })
    } else {
      this.loading(false)
    }
  }

  vpSubmit() {
    const hash = this.attributes()
    const data = {
      grade_level: hash.grade_level,
      phone_number: hash.phone_number,
      parent_phone_number: hash.parent_phone_number,
      school_major: hash.school_major,
      existing_user: true,
      email: hash.email,
      name: [hash.first_name, hash.last_name].join(' '),
      username: hash.username,
      province: hash.province,
      city: hash.city,
      has_chosen_college: hash.has_chosen_college === 'true',
    }

    if (this.state.customSchoolInput) {
      data.school_name = hash.custom_school
    } else {
      data.school_id = hash.school
      data.school_name = this.inputs.school.inputTag.textValue
    }

    API.post(API.endPoints().auth.vp_meta, data, { headers: { 'X-CSRF-Token': csrfToken() } }).then((response) => {
      const newCurrentUser = response.data
      newCurrentUser.first_name = hash.first_name
      newCurrentUser.last_name = hash.last_name
      newCurrentUser.school_name = response.data.school_name
      storage.set(['serverProps', 'currentUserProfile'], newCurrentUser)
      this.props.onClickCancel()
    })
  }

  handleChangePassword() {
    this.setState({ changePassword: !this.state.changePassword })
  }

  render() {
    /* eslint-disable camelcase */
    const {
      grade_level,
      school_major,
      phone_number,
      parent_phone_number,
      email,
      username,
      first_name,
      last_name,
      city,
      province,
      school_id,
      has_chosen_college,
    } = this.props.currentUser

    return (
      <div className="external-container">
        <div className="profile-name-header">
          <Typography variant="big" component="h1" className="m-b-lg">
            <Image src="/assets/img/avatar.png" className="avatar m-r-lg" />
          </Typography>
        </div>

        <form onSubmit={this.handleSubmit}>
          <Paper rounded elevation={1} className="p-a-lg m-y-md">
            <Typography variant="headline">Biodata</Typography>

            <ProfileRow label={intl.get('account.first_name')}>
              <Input
                ref={c => this.inputs.first_name = c}
                type="text"
                name="first_name"
                validations={['required']}
                embedErrorsInfo
                defaultValue={first_name}
              />
            </ProfileRow>

            <ProfileRow label={intl.get('account.last_name')}>
              <Input
                ref={c => this.inputs.last_name = c}
                type="text"
                name="last_name"
                validations={['required']}
                embedErrorsInfo
                defaultValue={last_name}
              />
            </ProfileRow>

            <ProfileRow label={intl.get('account.phone_number')}>
              <Input
                ref={c => this.inputs.phone_number = c}
                icon="flag-indonesia"
                type="tel"
                name="phone_number"
                validations={['required', 'phone_number']}
                embedErrorsInfo
                defaultValue={phone_number}
              />
            </ProfileRow>

            <ProfileRow label={intl.get('account.parent_phone_number')}>
              <Input
                ref={c => this.inputs.parent_phone_number = c}
                icon="flag-indonesia"
                type="tel"
                name="parent_phone_number"
                validations={['required', 'phone_number']}
                embedErrorsInfo
                defaultValue={parent_phone_number}
              />
            </ProfileRow>
          </Paper>

          <Paper rounded elevation={1} className="p-a-lg m-y-md">
            <Typography variant="headline">Informasi Sekolah</Typography>
            <ProfileRow label="Informasi Sekolah">
              <Input
                ref={c => this.inputs.province = c}
                icon="province"
                type="select"
                selectOptions={this.state.provinces}
                options={this.defaultSelectInputOptions(intl.get('account.province_of_your_school'))}
                name="province"
                validations={['required']}
                callback={this.fillCityOptions}
                defaultValue={province}
                embedErrorsInfo
              />

              <Input
                ref={c => this.inputs.city = c}
                icon="city"
                type="select"
                selectOptions={this.state.cities}
                options={this.defaultSelectInputOptions(intl.get('account.city_of_your_school'))}
                name="city"
                validations={['required']}
                callback={(c) => {
                  this.showSchoolSelect(c)
                  this.setState({ schools: [] })
                }}
                containerClassName={!this.state.citiesVisible ? 'hidden' : ''}
                defaultValue={city}
                embedErrorsInfo
              />

              <Input
                ref={c => this.inputs.school = c}
                icon="school"
                type="select"
                selectOptions={this.state.schools}
                name="school"
                options={this.schoolSelectInputOptions()}
                validations={['required']}
                containerClassName={!this.state.schoolsVisible ? 'hidden' : ''}
                defaultValue={school_id}
                embedErrorsInfo
              />
            </ProfileRow>


            <ProfileRow label={intl.get('account.your_grade_level')}>
              <Input
                ref={c => this.inputs.grade_level = c}
                name="grade_level"
                type="selectButton"
                selectOptions={this.state.gradeLevels}
                validations={['required']}
                callback={this.setSchoolMajor}
                embedErrorsInfo
                defaultValue={grade_level}
              />
            </ProfileRow>

            <ProfileRow
              label={intl.get('account.alumni_status')}
              className={this.attributes().grade_level !== 'over_g12' ? 'hidden' : ''}
            >
              <Input
                ref={c => this.inputs.has_chosen_college = c}
                name="has_chosen_college"
                type="radioButton"
                options={['false', 'true']}
                validations={['required']}
                translationKey="alumni_status"
                embedErrorsInfo
                defaultValue={typeof has_chosen_college === 'boolean' ? has_chosen_college.toString() : has_chosen_college}
              />
            </ProfileRow>

            <ProfileRow
              label={intl.get('account.your_school_major')}
              className={!this.state.majorsVisible ? 'hidden' : ''}
            >
              <Input
                ref={c => this.inputs.school_major = c}
                name="school_major"
                type="radioButton"
                options={['natural_sciences', 'social_sciences', 'other', 'not_yet_decided']}
                validations={['required']}
                translationKey="school_majors"
                embedErrorsInfo
                defaultValue={school_major}
              />
            </ProfileRow>
          </Paper>

          <Paper rounded elevation={1} className="p-a-lg m-y-md">
            <Typography variant="headline">Akun</Typography>
            <ProfileRow label={intl.get('account.email')}>
              <Input
                ref={c => this.inputs.email = c}
                name="email"
                type="text"
                validations={['required', 'email']}
                embedErrorsInfo
                defaultValue={email}
              />
            </ProfileRow>

            <ProfileRow label={intl.get('account.username')}>
              <Input
                ref={c => this.inputs.username = c}
                name="username"
                type="text"
                validations={['required', 'username']}
                embedErrorsInfo
                defaultValue={username}
              />
            </ProfileRow>

            <ProfileRow label={intl.get('account.password')}>
              {
                !this.state.changePassword &&
                <div className="form-group">
                  <a href="javascript:void(0)" onClick={this.handleChangePassword}>
                    Ganti Kata Sandi
                  </a>
                </div>
              }

              {
                this.state.changePassword &&
                <React.Fragment>
                  <Input
                    ref={c => this.inputs.current_password = c}
                    name="current_password"
                    label={intl.get('account.current_password')}
                    type="password"
                    validations={['required', 'contains_text_and_number', 'min_length']}
                    embedErrorsInfo
                  />

                  <Input
                    ref={c => this.inputs.password = c}
                    name="password"
                    type="password"
                    label={intl.get('account.new_password')}
                    validations={['required', 'contains_text_and_number', 'min_length']}
                    embedErrorsInfo
                  />

                  <div className="form-group">
                    <a href="javascript:void(0)" onClick={this.handleChangePassword}>
                      Batalkan Ganti Kata Sandi
                    </a>
                  </div>
                </React.Fragment>
              }
            </ProfileRow>
          </Paper>

          <FormGroup className="m-t-lg text-center">
            <Button color="primary" type="submit" onClick={this.handleSubmit} className="icon-loading-container">
              <i className="icon icon-loading icon-loading-center hide" ref={c => this.loader = c} />
              {intl.get('save')}
            </Button>
            <Button color="secondary" type="button" onClick={this.props.onClickCancel} className="icon-loading-container m-l-sm">
              {intl.get('cancel')}
            </Button>
          </FormGroup>
        </form>
      </div>
    )

    /* eslint-enable camelcase */
  }
}

ProfileEdit.propTypes = {
  currentUser: PropTypes.shape({
    name: PropTypes.string,
    phone_number: PropTypes.string,
    parent_phone_number: PropTypes.string,
    school_name: PropTypes.string,
    grade_level: PropTypes.string,
    school_major: PropTypes.string,
    username: PropTypes.string,
    email: PropTypes.string,
  }),
  onClickCancel: PropTypes.func,
}

ProfileEdit.defaultProps = {
  onClickCancel: () => {},
  currentUser: {},
}

export { ProfileEdit }
export default branch({
  currentUser: ['serverProps', 'currentUserProfile'],
}, ProfileEdit)
